import { FormBlankSpace } from './FormBlankSpace'

export const FormBlankSpacePrintEditor = (props) => {
  return <FormBlankSpace {...props} />
}
